<template>
    <div class="stepper mt-0 ml-3">
        <div class="step" v-for="(step, index) in    steps   " :key="index">
            <div class="step-circle" :class="getStepperCircleStatus(index)">
                <span v-if="index < currentStep" class="step-checkmark"><font-awesome-icon icon="check"
                        class="step-checkmark" /></span>
                <span v-if="index == currentStep" class="step-blackdot"></span>
            </div>
            <div class="step-label" :class="getStepperLabelStatus(index)"
                :style="{ marginLeft: index === 2 ? '40px' : index === 3 ? '75px' : '64px' }">
                {{ step }}
            </div>
            <div class="step-line" v-if="index < steps.length - 1"
                :class="{ active: index < currentStep, inactive: index > currentStep, completed: index < currentStep }">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        currentStep: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            steps: ['Begin Identity Verification', 'Download Nametag App', 'Generate QR Code', 'Complete Identity Verification']
        };
    },
    methods: {
        getStepperCircleStatus(index) {
            if (index < this.currentStep) return 'completed';
            if (index === this.currentStep) return 'active';
            return 'inactive';
        },
        getStepperLabelStatus(index) {
            if (index < this.currentStep) return 'completed';
            if (index === this.currentStep) return 'active';
            return 'inactive';
        }
    }
};
</script>

<style scoped>
.stepper {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 80%;
    margin: 20px 0;
    max-width: 1200px;
}

.step {
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
    position: relative;
}

.step-circle {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 2px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f0ebeb;
    position: relative;
    z-index: 1;
}

.step-circle.active {
    border-color: black;
    background-color: white;
}

.step-circle.completed {
    background-color: #2BC275;
    border-color: #2BC275;
}

.step-checkmark {
    font-size: 14px;
    color: black;
}

.step-blackdot {
    display: block;
    width: 8px;
    height: 8px;
    background-color: black;
    border-radius: 50%;
}

.step-label {
    margin-top: 14px;
    text-align: center;
    color: #ccc;
    font-weight: normal;
    position: absolute;
    font-size: 12px;
    top: 18px;
    white-space: nowrap;
    left: 50%;
    transform: translateX(-50%);
    color: gray;
}

.step-label.active {
    font-weight: bold;
    color: black;
}

.step-label.completed {
    color: black;
}

.step-line {
    height: 2px;
    flex-grow: 1;
    background-color: #ccc;
    position: absolute;
    top: 15px;
    left: calc(50% + 12px);
    right: calc(-50% - 12px);
    z-index: 0;
}

@media ((min-width: 700px) and (max-width: 900px)) {
    .step-label {
        margin-left: 0px !important;
    }

    .stepper {
        width: 100%;
    }
}

@media (max-width: 700px) {
    .stepper {
        flex-direction: column;
        align-items: flex-start;
        width: 60px;
        margin-top: 16px;
        margin-bottom: 0px;
        margin-left: 0px !important;
    }

    .step {
        flex-direction: row;
        align-items: flex-start;
        width: 100%;
    }

    .step-circle {
        margin-right: 10px;
        margin-left: 0px !important;
    }

    .step-label,
    .step-line,
    .step-circle.inactive {
        display: none;
    }

    .step-circle.completed {
        display: block;
        margin-bottom: 30px;
    }

    .step-circle.active {
        display: block;
    }

    .step-checkmark {
        margin: 6px 3px;
    }

    .step-blackdot {
        margin-left: 8px;
        margin-top: 8px;
    }
}
</style>
